/**
 * API 클라이언트
 * 환경변수로 Worker URL 설정
 */

const BASE = process.env.REACT_APP_WORKER_URL || "";

let authToken = localStorage.getItem("auth_token") || "";

export function setToken(token) {
  authToken = token;
  if (token) localStorage.setItem("auth_token", token);
  else localStorage.removeItem("auth_token");
}

export function getToken() { return authToken; }

export async function apiFetch(path, options = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...(authToken ? { "X-Auth-Token": authToken } : {}),
    ...(options.headers || {}),
  };
  const r = await fetch(`${BASE}${path}`, {
    ...options,
    credentials: "include",
    headers,
  });
  if (r.status === 401) {
    setToken("");
    window.location.reload();
  }
  return r;
}
